interface IMockedAssignees {
  alias: string
  crewSize: number
  description: string
  id: number
  resourceIds: number[]
  shiftHours: number
  supervisorId: number
  supervisorIds: number[]
}

export const mockedAssignees: IMockedAssignees[] = [
  {
    alias: 'A/M Crew',

    resourceIds: [583],
    description: 'Cotton Pinkerton',
    crewSize: 1,
    shiftHours: 8,
    supervisorId: 353,
    supervisorIds: [353],
    id: 837,
  },
  {
    alias: 'A/M Crew',

    resourceIds: [571],
    description: 'Tyler Campbell',
    crewSize: 1,
    shiftHours: 1,
    supervisorId: 363,
    supervisorIds: [363],
    id: 1000066,
  },
  {
    alias: 'A/M Crew',

    resourceIds: [571],
    description: 'Nic Maetche',
    crewSize: 1,
    shiftHours: 1,
    supervisorId: 363,
    supervisorIds: [363],
    id: 1000067,
  },
  {
    resourceIds: [596],
    description: 'Bbbb',
    crewSize: 1,
    shiftHours: 8,
    alias: 'B',
    supervisorId: 349,
    supervisorIds: [349],
    id: 1000178,
  },
  {
    resourceIds: [576, 590],
    description: 'crew 1',
    crewSize: 1,
    shiftHours: 8,
    alias: 'ANZ',
    supervisorId: 364,
    supervisorIds: [364, 355],
    id: 1000189,
  },
  {
    resourceIds: [
      569, 570, 571, 572, 573, 574, 575, 576, 577, 578, 579, 580, 581, 582, 583,
      584, 585, 586, 587, 588, 589, 590, 591, 592, 593, 594, 595, 596, 597, 598,
      623, 1335, 1906, 2024, 2185,
    ],
    description: 'Jack of All Trades',
    crewSize: 1,
    shiftHours: 8.1,
    alias: 'JAT',
    supervisorId: 343,
    supervisorIds: [
      343, 345, 363, 345, 347, 348, 349, 364, 345, 350, 351, 350, 345, 352, 353,
      345, 350, 353, 342, 349, 349, 355, 356, 344, 349, 349, 349, 349, 352, 349,
      364, 345, 349, 343, 344,
    ],
    id: 1000190,
  },
]
